import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "fill-a-form-from-audio",
  courseId: "forms",
  order: 3,
  title: "Fill from audio",
  summary:
    "Dictate the details and the AI fills the form, with a confidence score on each field so you know what to check.",
  learn: [
    "Fill a form from a recording, an upload, a case, or a library file",
    "Review AI confidence and fix low-confidence fields",
    "Save and export the filled PDF",
  ],
  minutes: 4,
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "You have a tow sheet or a property receipt to complete and the details are already in your head or in a report. Pick a source, let the AI fill the form, and check the fields it was unsure about.",
    },
    {
      type: "steps",
      items: [
        "Open **Forms**, pick the template, and click **Fill Form**.",
        "Choose a source: **Record Audio** (dictate the fields in any order), **Upload Audio**, **From a Case** (use a report you already wrote), or **From Files** (a recording in your library).",
        "Wait for the fill. The form opens in the Form Editor with values in place.",
        "Turn on Show AI Confidence. Low-confidence fields are highlighted.",
        "Check the highlighted fields against the audio or the case, and fix anything wrong by clicking the field.",
        "Use Add Text or Checkbox for a stray annotation the template did not anticipate.",
        "Click **Save**, then **Export PDF**.",
      ],
    },
    {
      type: "callout",
      tone: "tip",
      title: "From a Case is the fast path",
      text: "If the report is already written, **From a Case** fills the form from the narrative with nothing to record. From inside a case, **Export** then **Fill Forms** does the same thing and lets you pick the template.",
    },
    {
      type: "callout",
      tone: "note",
      title: "When dictating, say the field names",
      text: "For example: \"Plate, seven Adam Boy Charlie one two three. Tow company, Valley Towing.\" The AI maps your words to the fields by name and context, so naming them removes guesswork.",
    },
    {
      type: "paragraph",
      text: "Filled forms are saved as submissions under the template. To get back to one, open **View forms** from the **Export to a form** picker, or use the template's submissions list. If you learn more later, \"Add to a form\" shows how to update it.",
    },
  ],
  related: ["add-to-a-filled-form", "form-outputs", "design-fields-and-sections"],
};

export default lesson;
